export const SHORTLIST_RESOURCE_MAX_COUNT = 999;